import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";
import { useAuth } from "@/lib/auth";
import BrandLogo from "@/components/BrandLogo";
import { Button } from "@/components/ui/button";

export default function PublicSiteHeader({ showAuthActions = true }) {
  const { lang, setLang, t } = useLang();
  const { user } = useAuth();
  const signedIn = user && typeof user === "object";

  return (
    <header className="flex items-center justify-between px-8 lg:px-14 py-6 border-b border-slate-200">
      <Link to="/" className="flex items-center gap-3" data-testid="public-brand-link">
        <BrandLogo size="md" alt={t("appName")} />
        <div className="leading-tight">
          <div className="font-serif-display text-xl text-slate-900">{t("appName")}</div>
          <div className="eyebrow !text-[9px] !tracking-[0.3em]">{t("appTagline")}</div>
        </div>
      </Link>

      <div className="flex items-center gap-2 sm:gap-3">
        <Link
          to="/how-it-works"
          data-testid="public-hiw-link"
          className="text-xs text-slate-600 hover:text-slate-900 underline-offset-4 hover:underline px-1 sm:px-2"
        >
          {t("hiw_nav")}
        </Link>
        <Button
          data-testid="public-lang-toggle"
          variant="outline"
          size="sm"
          onClick={() => setLang(lang === "ar" ? "en" : "ar")}
          className="rounded-none border-slate-300 h-9 px-3 font-mono-tight text-xs tracking-wide"
          aria-label={lang === "ar" ? "Switch to English" : "التبديل إلى العربية"}
        >
          {lang === "ar" ? "EN" : "AR"}
        </Button>
        {showAuthActions && (
          <>
            {signedIn ? (
              <Button
                asChild
                size="sm"
                data-testid="public-workspace-link"
                className="rounded-none bg-slate-900 hover:bg-slate-800 text-white h-9 text-xs"
              >
                <Link to="/workspace">{t("hiw_go_workspace")}</Link>
              </Button>
            ) : (
              <>
                <Button
                  asChild
                  variant="outline"
                  size="sm"
                  data-testid="landing-sign-in"
                  className="rounded-none border-slate-300 h-9 text-xs hidden sm:inline-flex"
                >
                  <Link to="/login">{t("landing_sign_in")}</Link>
                </Button>
                <Button
                  asChild
                  size="sm"
                  data-testid="landing-get-started"
                  className="rounded-none bg-slate-900 hover:bg-slate-800 text-white h-9 text-xs"
                >
                  <Link to="/login">{t("landing_cta")}</Link>
                </Button>
              </>
            )}
          </>
        )}
      </div>
    </header>
  );
}
